// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Jv72D","content":"styles_content__1s0PM","row":"styles_row__29PBk","footer":"styles_footer__3nu_B","phraseLength":"styles_phraseLength__3x643"};